/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Cta_H3Inputs */

const es_faq_cta_h3 = /** @type {(inputs: Faq_Cta_H3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Listo para empezar?`)
};

const gl_faq_cta_h3 = /** @type {(inputs: Faq_Cta_H3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listo para comezar?`)
};

const en_faq_cta_h3 = /** @type {(inputs: Faq_Cta_H3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready to get started?`)
};

/**
* | output |
* | --- |
* | "Ready to get started?" |
*
* @param {Faq_Cta_H3Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_cta_h3 = /** @type {((inputs?: Faq_Cta_H3Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Cta_H3Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_faq_cta_h3(inputs)
	if (locale === "en") return en_faq_cta_h3(inputs)
	return es_faq_cta_h3(inputs)
});